/*
 * @Description:
 * @Author: yuqing.hao
 * @Date: 2020-10-19 15:21:42
 * @LastEditTime: 2021-05-18 14:40:23
 * @LastEditors: Wang Bingjing
 */
import Config from '../config';
import { getApi, postApi, deleteApi } from './apiUtil';
import {getToken} from '../common/session'
const { getRequestParamsStr } = require("../common/Utils");

const token = getToken()

class loginApi {
	static requestUrl() {
		const url = `${Config.serverUrl}`;
		return url;
	}

	static login(params) {
		const url = `${this.requestUrl()}auth`;
		const body = JSON.stringify({...params,token:''});
		return postApi(url,body);
	}

	static async loadUserList(params) {
		const url = `${this.requestUrl()}user${getRequestParamsStr({...params,token:getToken()})}`;
		return getApi(url)
	}

	static createUser(params) {
		const url = `${this.requestUrl()}user/create`;
		const body = JSON.stringify({...params,token:getToken()});
		return postApi(url, body);
	}

	static updateUser(params) {
		const url = `${this.requestUrl()}user`;
		const body = JSON.stringify({...params,token:getToken()});
		return postApi(url, body);
	}

	static deleteUser(params) {
		const url = `${this.requestUrl()}user`;
		const data = {...params,token:getToken()}
		return deleteApi(url, data);
	}

	static updatePassword(params) {
		const url = `${this.requestUrl()}user`;
		const body = JSON.stringify({...params,token:getToken()});
		return postApi(url, body);
	}
}

export default loginApi;
